<template lang="pug">
  .fixed.z-10.inset-0.overflow-y-auto
    .flex.items-end.justify-center.min-h-screen.pt-4.px-4.pb-20.text-center(class="sm:block sm:py-0")
      //
        Background overlay, show/hide based on modal state.
        Entering: "ease-out duration-300"
        From: "opacity-0"
        To: "opacity-100"
        Leaving: "ease-in duration-200"
        From: "opacity-100"
        To: "opacity-0"
      .modal-background.fixed.inset-0.transition-opacity(aria-hidden="true" @click="$emit('dismiss')")
        .absolute.inset-0.bg-gray-900.opacity-75
          button.modal-close(aria-label="close" @click="$emit('close')")
            font-awesome-icon(icon="times")
      // This element is to trick the browser into centering the modal contents.
      span.hidden(class="sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true") &ZeroWidthSpace;
      //
        Modal panel, show/hide based on modal state.
        Entering: "ease-out duration-300"
        From: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
        To: "opacity-100 translate-y-0 sm:scale-100"
        Leaving: "ease-in duration-200"
        From: "opacity-100 translate-y-0 sm:scale-100"
        To: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
      .modal-content.inline-block.align-bottom.bg-white.rounded.text-left.shadow-xl.transform.transition-all(
        :class="size"
        role="dialog"
        aria-modal="true"
        aria-labelledby="modal-headline"
      )
        slot
</template>

<script>
export default {
  name: 'Modal',
  props: {
    size: {
      type: String,
      validator: value => ['sm', 'md', 'lg'].includes(value)
    }
  },
  beforeMount() {
    document.documentElement.classList.add('overflow-hidden');
  },
  beforeDestroy() {
    document.documentElement.classList.remove('overflow-hidden');
  }
};
</script>

<style lang="sass" scoped>
button.modal-close
  @apply inline-flex items-center justify-center w-8 h-8 text-gray-800 transition-colors duration-150 bg-gray-200 rounded-full text-lg
  outline: none
  position: absolute
  right: 1rem
  top: 1rem
  &:focus
    @apply shadow-outline
    background-color: var(--color-primary)
    --switch:calc((var(--primary-color-l) - var(--contrastThreshold)) * -100)
    color: hsl(0, 0%, var(--switch))
  &:hover
    background-color: var(--color-primary)
    --switch:calc((var(--primary-color-l) - var(--contrastThreshold)) * -100)
    color: hsl(0, 0%, var(--switch))

.modal-content
  @apply w-full
  @screen sm
    @apply my-8 align-middle max-w-2xl
    &.sm
      @apply max-w-xl
    &.md
      @apply max-w-4xl
    &.lg
      @apply max-w-6xl
  &::v-deep
    button
      @apply mr-2
      &:last-child
        margin-right: 0
</style>
